const parts = ['container', 'button', 'panel', 'icon']

const baseStyleContainer = {
  border: '1px solid',
  borderColor: 'primary.400',
  borderRadius: 'lg',
}

const baseStyleButton = {
  fontSize: '1rem',
  justifyContent: 'space-between',
  _focus: {
    boxShadow: 'none',
  },
  _hover: {
    bg: 'blackAlpha.50',
  },
  _disabled: {
    opacity: 0.4,
    cursor: 'not-allowed',
  },
  px: 4,
  py: 2,
}

const baseStylePanel = {
  pt: 2,
  px: 4,
  pb: 3,
}

const baseStyleIcon = {
  fontSize: '1.25em',
}

const baseStyle = {
  container: baseStyleContainer,
  button: baseStyleButton,
  panel: baseStylePanel,
  icon: baseStyleIcon,
}

export default {
  parts,
  baseStyle,
}
